<template>
    <label :for="`product-${group.id}-${product.id}`" class="product-name"> {{ product.name[lang]}} </label>
    <button v-if="got(product, 'details', lang)"
            type="button"
            role="button"
            class="toggle-btn"
            :class="{active: isOpen}"
            aria-expanded="true"
            @click="toggleOpen">

        <span class="screen-reader-text">{{ copydeck.accessibility.txt_show_more_information[lang] }}</span>
        <span class="arrow" role="presentation"></span>
    </button>
    <span class="price">{{ product.price }}$</span>

    <div class="actions_group">
        <order-counter
            :value="getValue(product)"
            max="9"
            :group-index="groupIndex"
            :product="product"
            @change="onOrderChange"
        />


    </div>

    <div
        class="toggle-content"
        :class="{visible: isOpen}"
        :id="`p-${groupIndex}-${productIndex}`"
        v-if="product.details"
        v-html="(product.details[lang] ?? '')">

    </div>
</template>

<script>
export default {
    name: "ProductCounter"
}
</script>

<script setup>

import { ref } from "vue";
import {useMainStore} from "../stores/main";
import {storeToRefs}  from "pinia";
import OrderCounter   from "./OrderCounter.vue";

let props = defineProps (["group", "groupIndex", "product", "productIndex",  "getOrder", "isOpen", "onOrderChange", "got"]);
let store = useMainStore();
let { copydeck,  lang } = storeToRefs(store);

let isOpen = ref(false);

function getValue (product)
{
    let value = props.getOrder(product);

    return value;
}
function toggleOpen ()
{
    isOpen.value = !isOpen.value;
    // setTimeout( () => parent.resizeIframe(), 300);
}

</script>
